import './OverviewBase.css';

function AboutOverview() {
  const overviewData = [
    { title: '회사명', value: '주식회사 타마' },
    { title: '사업자등록번호', value: '130-86-67102' },
    { title: '대표자', value: '조 선 철' },
    { title: '본점소재지', value: <>우-08592) 서울특별시 금천구 가산디지털1로 75-15 (하우스디와이즈타워, 926-927)<br />TEL. 02-448-2871<br />FAX. 02-448-2872<br />mail. tama@ta-ma.net</> },
    { title: '업종', value: '제조업(산업처리공정 제어장비 제조, 전자부품)' },
    { title: '법인설립일', value: '2012년 02월 03일' },
    { title: '주요사업', value: <>산업처리공정 제어장비 제조<br />Motor Controller, Encoder Motor 제조<br />Interface/IO Board 제조<br />ICT/IoT 솔루션 서비스</> }
  ];

  return (
    <div className="overview-container">
      <div className="heat-section-title">회사개요</div>
      <div className="overview-table">
        {overviewData.map((item, index) => (
          <div key={index} className="overview-row">
            <div className="overview-title">{item.title}</div>
            <div className="overview-value">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AboutOverview;

